<div class="footer">
    <div class="row footer-color" style="font-size: 14px;">
        <div class="col-12  col-md-4">
            <div class="p-3 text-white text-center">
                <span> {{ 'FOOTER.LABEL1' | translate }} </span><span style="white-space:nowrap;"> {{ 'FOOTER.LABEL2' | translate }} </span>
            </div>
        </div>
        <div class="col-12  col-md-4">
            <div class="p-3 text-white text-center">
                {{ 'FOOTER.LABEL3' | translate }} 
            </div>
        </div>
        <div class="col-12 col-md-4">
            <div class="p-3 text-white text-center">
                <a class="text-decoration-none text-reset"
                    href="https://pif.liverpool.com.mx/condiciones-generales"> {{ 'FOOTER.LABEL4' | translate }} </a> {{ 'FOOTER.LABEL5' | translate }} <a
                    class="text-decoration-none text-reset"
                    href="https://pif.liverpool.com.mx/aviso-de-privacidad"> {{ 'FOOTER.LABEL6' | translate }} </a>
                 <!--   <app-language-plugin class="d-flex justify-content-end pt-4"></app-language-plugin>-->
            </div>        
        </div>
    </div>
    <div class="row footer-color2" style="font-size: 11px;">
        <div class="col">
            <div class="text-white text-center">
                <div class="p-3"> {{ 'FOOTER.LABEL7' | translate }} </div>
            </div>
        </div>
    </div>
</div>